import { TaxBookRequest, TaxBookResponse } from 'routes/main/taxInvoice/types';

export const TAX_BOOK_REQUEST = "TAX_BOOK_REQUEST";
export const TAX_BOOK_SUCCESS = "TAX_BOOK_SUCCESS";
export const TAX_BOOK_ERROR = "TAX_BOOK_ERROR";
export const TAX_BOOK_RESET = "TAX_BOOK_RESET";

export interface TaxBookRequestAction {
  type: typeof TAX_BOOK_REQUEST;
  payload: TaxBookRequest;
}

export interface TaxBookSuccessAction {
  type: typeof TAX_BOOK_SUCCESS;
  payload: TaxBookResponse;
}

export interface TaxBookErrorAction {
  type: typeof TAX_BOOK_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface TaxBookResetAction {
  type: typeof TAX_BOOK_RESET;
}

export type TaxBookAction =
  | TaxBookRequestAction
  | TaxBookSuccessAction
  | TaxBookErrorAction
  | TaxBookResetAction;


